import React, { Component } from 'react'
import * as motion from "../../assets/images/motion-sickness.png";


export default class MotionSickness extends Component {
  render() {
      const {onClick} = this.props;
    return (
        <div className="row mt-5">
          <div className="col-lg-6 text-center"> 
            <img src={motion} width="250" alt="motion"/>
          </div>

          <div className="col-lg-6">
            
            <h2>Motion Sickness</h2>
          
            <div className="">
                <p className="mt-2">Does the dizziness happen most often while in a moving vehicle like a car or boat?</p>

                <div className="row mt-5">
              
                    <button className="btn btn-danger offset-lg-1 col-lg-4"  onClick={onClick.bind(this,24,true)}>Yes</button>
                    <button className="btn btn-danger  offset-lg-1 col-lg-4"  onClick={onClick.bind(this,9,false)}>No</button>
                  
                </div>
            </div>
          </div>
        </div>

    )
  }
}
